(function () {
  var controllerId = "pageController";

  angular
    .module("app")
    .controller(controllerId, ["$scope", "$rootScope", "$location",
      function pageController($scope, $rootScope, $location) {

        $scope.getClass = function (path) {
          if ($location.path().substr(0, path.length) === path) {
            return "active";
          } else {
            return "";
          }
        };

        /////////////////////////////////////////////////////////////////
        // Event handlers section
        /////////////////////////////////////////////////////////////////

      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/account/page.controller.js